import {
  getBotFormBacktestingQuery,
  getBotFormBacktestingRoute,
  getBotFormRoute,
} from "utils/routes";
import { useHistory } from "react-router-dom";
import { BacktestingRunType, BotType, OpenMessage } from "@shared/types";
import useSharedBacktestingActions from "@shared/features/bots/BotForm/Backtesting/useSharedBacktestingActions";
import { useNavigateToBacktestDetails } from "features/bots/common/hooks";
import {
  BacktestActions,
  BotFormType,
} from "@shared/features/bots/BotForm/common/types";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import SettingOutlined from "@ant-design/icons/SettingOutlined";
import React, { useMemo } from "react";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery.ts";

interface useBacktestingActionsProps {
  data?: BacktestingRunType;
  openDeleteModal: () => void;
  openMessage: OpenMessage;
  isSelected?: boolean;
  isBotForm?: boolean;
  botType: BotType;
}

const useBacktestingActions = ({
  data,
  openDeleteModal,
  openMessage,
  isSelected,
  isBotForm,
  botType,
}: useBacktestingActionsProps) => {
  const history = useHistory();
  const { appendQuery } = useHistoryWithQuery();
  const { navigateToBacktestDetails } = useNavigateToBacktestDetails();

  const navigateToFormBacktesting = (
    liveBacktestingData: BacktestingRunType
  ) => {
    if (isBotForm) {
      appendQuery(
        getBotFormBacktestingQuery(
          liveBacktestingData?.bot_id,
          liveBacktestingData?.id
        ),
        undefined,
        false
      );
    } else {
      history.push(
        getBotFormBacktestingRoute(
          getBotFormRoute(botType, BotFormType.CREATE),
          liveBacktestingData?.bot_id,
          liveBacktestingData?.id
        )
      );
    }
  };

  const {
    menuItems: sharedMenuItems,
    openExtraDetailsDrawer,
    status,
  } = useSharedBacktestingActions({
    data,
    openDeleteModal,
    openMessage,
    isSelected,
    navigateToFormBacktesting,
    navigateToBacktestDetails,
  });

  const getIcon = (key: string) => {
    if (key === BacktestActions.DELETE) return <DeleteOutlined />;
    else if (key === BacktestActions.SHOW_DETAILS)
      return <InfoCircleOutlined />;
    else if (key === BacktestActions.APPLY_CONFIGURATION)
      return <SettingOutlined />;
  };

  const menuItems = useMemo(() => {
    return sharedMenuItems.map((item) => ({
      ...item,
      icon: getIcon(item.key),
    }));
  }, [sharedMenuItems]);

  return {
    menuItems,
    openExtraDetailsDrawer,
    status,
  };
};

export default useBacktestingActions;
